import { Theme } from './../index.d';
import UI_THEME_DEFAULT from './UI_THEME_DEFAULT';

const UI_THEME_CMCAPITAL: Theme = {
  pallete: {
    ...UI_THEME_DEFAULT.pallete,
    logo: 'url("/assets/images/milenio-bars-logo.png")',
    'logo-horizontal': 'url("/assets/images/logo-milenio.png")',
  },
  brand: {
    ...UI_THEME_DEFAULT.brand,
    name: 'Milenio Capital',
    desc: 'Módulo de cadastro',
    prefix: 'milenio',
    footerText: 'Milenio Capital - Todos os direitos reservados 2022',
    logoText: 'Milenio Capital',
    logoWidth: 30,
    minWidth: 60,
    logo: '/assets/images/milenio-bars-logo.png',
    logoHorizontal: '/assets/images/logo-milenio.png',
    favicon: '/assets/favicon/milenio-favicon.ico',
    simplifiedFund: true,
  },
  api: {
    ...UI_THEME_DEFAULT.api,
    // local: 'http://localhost:8000',
    local: 'https://stage.api.data.milenio.prosperita.io',
    dev: 'https://dev.api.data.milenio.prosperita.io',
    stage: 'https://stage.api.data.milenio.prosperita.io',
    prod: 'https://api.data.milenio.prosperita.io',
    clarity_id: 'fhco559uuk',
  },
};

export default UI_THEME_CMCAPITAL;
